import {
  GET_CONSUMPTION_REQUEST,
  GET_CONSUMPTION_SUCCESS,
  GET_CONSUMPTION_FAILURE,
  DOWNLOAD_CONSUMPTION_REQUEST,
  DOWNLOAD_CONSUMPTION_SUCCESS,
  DOWNLOAD_CONSUMPTION_FAILURE,
} from "./consumptionTypes";
import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;

const getConsumptionReportRequest = () => {
  return {
    type: GET_CONSUMPTION_REQUEST,
  };
};

const getConsumptionReportSuccess = (payload) => {
  return {
    type: GET_CONSUMPTION_SUCCESS,
    payload: payload,
  };
};

const getConsumptionReportFailure = (error) => {
  return {
    type: GET_CONSUMPTION_FAILURE,
    payload: error,
  };
};

const getConsumptionReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getConsumptionReportRequest());
    let url = `${baseUrl}/reports/consumption?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getConsumptionReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getConsumptionReportFailure(err.response));
      });
  };
};

const downloadConsumptionReportRequest = () => {
  return {
    type: DOWNLOAD_CONSUMPTION_REQUEST,
  };
};

const downloadConsumptionReportSuccess = (payload) => {
  return {
    type: DOWNLOAD_CONSUMPTION_SUCCESS,
    payload: payload,
  };
};

const downloadConsumptionReportFailure = (error) => {
  return {
    type: DOWNLOAD_CONSUMPTION_FAILURE,
    payload: error,
  };
};

const downloadConsumptionReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadConsumptionReportRequest());
    let url = `${baseUrl}/reports/consumption?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadConsumptionReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadConsumptionReportFailure(err.response));
      });
  };
};

export { getConsumptionReport, downloadConsumptionReport };
